module.exports = __webpack_public_path__ + "img/account.9088c5a1.svg";